var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaDocumenti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_documenti",
    "data-name": "icona documenti",
    transform: "translate(-398 -79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_documenti-2",
    "data-name": "icona documenti",
    transform: "translate(-93 -52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_documento_generato",
    "data-name": "icona documento generato",
    transform: "translate(492 131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_166",
    "data-name": "Tracciato 166",
    d: "M9.874,14H1.833A1.8,1.8,0,0,1,0,12.25V1.75A1.8,1.8,0,0,1,1.833,0h8.334A1.8,1.8,0,0,1,12,1.75V12.874a.5.5,0,0,1-1,0V1.75a.816.816,0,0,0-.833-.8H1.833A.816.816,0,0,0,1,1.75v10.5a.816.816,0,0,0,.833.8h8.04a.478.478,0,1,1,0,.955Z",
    transform: "translate(2 2)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_167",
    "data-name": "Tracciato 167",
    d: "M10.5,14.455h-7a.478.478,0,1,1,0-.955h7a.478.478,0,1,1,0,.955Z",
    transform: "translate(1 -2.909)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_168",
    "data-name": "Tracciato 168",
    d: "M10.5,10.455h-7a.478.478,0,1,1,0-.955h7a.478.478,0,1,1,0,.955Z",
    transform: "translate(1 -1.455)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_169",
    "data-name": "Tracciato 169",
    d: "M7.167,6.455H3.5a.478.478,0,1,1,0-.955H7.167a.478.478,0,1,1,0,.955Z",
    transform: "translate(1 0)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2201",
    "data-name": "Tracciato 2201",
    d: "M2.627,14H1.833A1.8,1.8,0,0,1,0,12.25V1.75A1.8,1.8,0,0,1,1.833,0h8.334A1.8,1.8,0,0,1,12,1.75c.25,2.083-.333.917-1,0a.816.816,0,0,0-.833-.8H1.833A.816.816,0,0,0,1,1.75v10.5a.816.816,0,0,0,.833.8l.793-.172c.276,0,0,.2,0,.46S2.9,14,2.627,14Z",
    fill: "#4e4e4e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1833",
    "data-name": "Rettangolo 1833",
    transform: "translate(398 79)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaDocumenti);
export default __webpack_public_path__ + "static/media/icona_documenti.27b80bdd247af75b6dfa4afd2adc8b92.svg";
export { ForwardRef as ReactComponent };